import * as Backbone from "backbone";
import {InsecureCachingCollection} from "./_BaseCollection";


export class BrandCollection extends InsecureCachingCollection<Backbone.Model> {
    url = () => {
        return window.location.origin + '/brands?q=' + encodeURIComponent(window.location.origin);
    };

    getBrand() {
        return this.first();
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/Brands.ts